import { Area, AreaContent } from "../../useAreas/areas/types";
import hero from "../../../../assets/image/areas/hero/transportrecht.webp";

const data: AreaContent = {
  id: Area.TRANSPORTRECHT,
  hero: hero,
  content: [
    "Wir beraten und vertreten Transport-, Speditions- und Logistikunternehmen im In- und Ausland in fracht-, transport- und speditionsrechtlichen Angelegenheiten.",
    "Dazu gehören innerdeutsche Frachtgeschäfte nach dem HGB ebenso wie grenzüberschreitende Straßentransporte nach CMR. Wir unterstützen Sie bei der Gestaltung vertraglicher Grundlagen, bei der Abwicklung von Schäden sowie bei der Abwehr und Durchsetzung transportrechtlicher Ansprüche.",
    "Wir beraten und vertreten Sie insbesondere bei:",
    [
      "der Geltendmachung und Abwehr von Frachtansprüchen",
      "der Geltendmachung und Abwehr von Schäden aus Verkehrsunfällen mit Transportfahrzeugen",
      "der Geltendmachung und Abwicklung von Transport- und Folgeschäden",
      "Lagerhaltung, Güterumschlag und Logistik",
      "Lademitteln und Gefahrguttransporten",
      "transportversicherungsrechtlichen Fragen",
      "der Erstellung und Prüfung von Transport-, Speditions- und Logistikverträgen",
      "Fragen zu HGB, CMR und ADSp",
      "der Abwehr von Arbeits- und Lenkzeitüberschreitungen",
      "der Abwehr von Verstößen gegen Zollvorschriften, Mautgesetze und Verkehrssteuern",
    ],
    "Die Allgemeinen Deutschen Spediteurbedingungen, kurz ADSp, sind für viele Speditions- und Logistikverträge ein wichtiges Regelwerk. Sie konkretisieren typische Rechte und Pflichten im Transport- und Speditionsgeschäft und können helfen, vertragliche Lücken praxisnah zu schließen.",
  ],
  bullets: [
    "Vertragsgestaltung nach HGB, CMR und ADSp",
    "Transportrecht",
    "Speditionsrecht",
    "Logistikrecht",
    "Transportschadenabwicklung",
    "Frachtansprüche",
    "Lademittel",
    "Gefahrguttransport",
    "Transportversicherungsrecht",
    "Lagerei und Güterumschlag",
    "Arbeits- und Lenkzeitüberschreitungen",
    "Zoll, Maut und Verkehrssteuern",
  ],
  more: [],
};

export default data;
